<div class="animate-text-container whitespace-pre-wrap">
    <ng-container *ngFor="let segment of segments; let i = index">
        <!-- 根据当前动画类型选择正确的动画触发器 -->
        <span *ngIf="ncAnimation === 'fadeIn'" [class]="getSegmentClass(i)"
            [@fadeIn]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'blurIn'" [class]="getSegmentClass(i)"
            [@blurIn]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'blurInUp'" [class]="getSegmentClass(i)"
            [@blurInUp]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'blurInDown'" [class]="getSegmentClass(i)"
            [@blurInDown]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'slideUp'" [class]="getSegmentClass(i)"
            [@slideUp]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'slideDown'" [class]="getSegmentClass(i)"
            [@slideDown]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'slideLeft'" [class]="getSegmentClass(i)"
            [@slideLeft]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'slideRight'" [class]="getSegmentClass(i)"
            [@slideRight]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'scaleUp'" [class]="getSegmentClass(i)"
            [@scaleUp]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
        <span *ngIf="ncAnimation === 'scaleDown'" [class]="getSegmentClass(i)"
            [@scaleDown]="{value: getSegmentState(i), params: getAnimationParams(i)}">{{segment}}</span>
    </ng-container>
</div>